(() => {
  // Inject a signup form into the body of an article for users not logged in
  if (!window.isUserLoggedIn) {
    const inlineForm = document.querySelector('[data-inline-signup]');
    const inlineFormInjectionPoint = document.querySelector('[data-inject-inline-signup]');

    if (inlineFormInjectionPoint) {
      inlineFormInjectionPoint?.appendChild(inlineForm);
      inlineForm?.classList.add('inline-signup__ready');
    }
  }
})();